import React from "react";
import Typewriter from "typewriter-effect";
import { Typography } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";

const useStyle = makeStyles((theme) => ({
  staticHead: {
    marginBottom: "8rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "4rem",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "3rem",
    },
  },
}));

const LandingHeader = (props) => {
  const theme = useTheme();
  const { phraseOne, phraseTwo, typeWriterData } = props;
  const classes = useStyle(theme);
  return (
    <>
      <Typography className={classes.staticHead} variant="h1">
        {phraseOne ? phraseOne : null}
        <b style={{ color: "#6C63FF" }}>
          <Typewriter
            options={{
              strings: typeWriterData,
              autoStart: true,
              loop: true,
              skipAddStyles: false,
            }}
          />
        </b>
        {phraseTwo ? phraseTwo : null}
      </Typography>
    </>
  );
};

export default LandingHeader;
